var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"one-site-sections-view mb-2"},[_c('b-row',{staticClass:"one-site-sections-view"},[_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('one-site-sections-node-list',{attrs:{"site-section":_vm.siteSection}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","lg":"8"}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }